<div class="bg-[#d6d1cd] text-black w-full max-w-[560px]">
  <!-- Header -->
  <div
    class="flex items-start justify-between gap-6 px-6 md:px-10 pt-6 md:pt-8"
  >
    <div>
      <h2
        class="font-primary text-3xl md:text-4xl font-bold tracking-wide uppercase"
      >
        Kontakt
      </h2>
      <p class="mt-2 font-primary text-black/80 text-base md:text-lg">
        Sende uns eine Nachricht – wir melden uns zeitnah.
      </p>
    </div>

    <button
      type="button"
      class="w-10 h-10 border border-black/60 hover:border-black flex items-center justify-center bg-transparent hover:bg-black/5 transition text-2xl leading-none"
      (click)="close()"
      aria-label="Schließen"
    >
      ×
    </button>
  </div>

  <!-- Content -->
  <div class="px-6 md:px-10 pb-8 md:pb-10 pt-6">
    @if (!submitted) {
      <form
        class="border-2 border-black p-6 md:p-8"
        [formGroup]="contactForm"
        (ngSubmit)="onSubmit()"
        data-netlify="true"
        netlify-honeypot="bot-field"
      >
        <input type="hidden" name="form-name" value="contactForm" />
        <input
          type="text"
          name="bot-field"
          class="hidden"
          tabindex="-1"
          autocomplete="off"
        />
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div>
            <label
              for="firstName"
              class="block font-primary text-sm tracking-[0.14em] uppercase mb-2"
            >
              Vorname
            </label>
            <input
              type="text"
              formControlName="firstName"
              id="firstName"
              class="w-full bg-transparent border-2 border-black px-4 py-3 font-primary outline-none placeholder:text-black/50 hover:bg-black/5 focus:bg-transparent focus:ring-2 focus:ring-black/20 focus:border-black"
              placeholder="Max"
            />
          </div>

          <div>
            <label
              for="lastName"
              class="block font-primary text-sm tracking-[0.14em] uppercase mb-2"
            >
              Nachname
            </label>
            <input
              type="text"
              formControlName="lastName"
              id="lastName"
              class="w-full bg-transparent border-2 border-black px-4 py-3 font-primary outline-none placeholder:text-black/50 hover:bg-black/5 focus:bg-transparent focus:ring-2 focus:ring-black/20 focus:border-black"
              placeholder="Mustermann"
            />
          </div>
        </div>

        <div class="mt-5">
          <label
            for="email"
            class="block font-primary text-sm tracking-[0.14em] uppercase mb-2"
          >
            E-Mail
          </label>
          <input
            type="email"
            formControlName="email"
            required
            id="email"
            class="w-full bg-transparent border-2 border-black px-4 py-3 font-primary outline-none placeholder:text-black/50 hover:bg-black/5 focus:bg-transparent focus:ring-2 focus:ring-black/20 focus:border-black"
            placeholder="deine@email.de"
          />
        </div>

        <div class="mt-5">
          <label
            for="phone"
            class="block font-primary text-sm tracking-[0.14em] uppercase mb-2"
          >
            Telefon (optional)
          </label>
          <input
            type="tel"
            formControlName="phone"
            id="phone"
            class="w-full bg-transparent border-2 border-black px-4 py-3 font-primary outline-none placeholder:text-black/50 hover:bg-black/5 focus:bg-transparent focus:ring-2 focus:ring-black/20 focus:border-black"
            placeholder="+49 171 2345678"
          />
        </div>

        <div class="mt-5">
          <label
            for="other"
            class="block font-primary text-sm tracking-[0.14em] uppercase mb-2"
          >
            Nachricht
          </label>
          <textarea
            formControlName="other"
            rows="5"
            id="other"
            class="w-full bg-transparent border-2 border-black px-4 py-3 font-primary outline-none placeholder:text-black/50 hover:bg-black/5 focus:bg-transparent focus:ring-2 focus:ring-black/20 focus:border-black"
            placeholder="Wie können wir helfen?"
          ></textarea>
        </div>

        @if (error) {
          <div class="mt-4 font-primary text-sm text-red-700">
            Leider hat es nicht geklappt. Bitte versuche es später nochmal.
          </div>
        }

        <!-- Actions -->
        <div
          class="mt-8 flex flex-col md:flex-row gap-4 md:items-center md:justify-between"
        >
          <button
            type="button"
            class="w-full md:w-auto px-10 py-3 md:px-12 md:py-3.5 font-primary font-semibold uppercase tracking-[0.18em] border-2 border-black/40 text-black/70 hover:text-black transition hover:bg-black/5"
            (click)="close()"
          >
            Abbrechen
          </button>

          <button
            type="submit"
            class="w-full md:w-auto px-10 py-3 md:px-12 md:py-3.5 font-primary font-semibold uppercase tracking-[0.18em] border-2 border-black transition duration-300 disabled:opacity-50 bg-black text-[#d6d1cd] hover:bg-black/90"
            [disabled]="submitting"
          >
            @if (!submitting) {
              Senden
            } @else {
              Senden…
            }
          </button>
        </div>
      </form>
    } @else {
      <!-- Success State -->
      <div class="border-2 border-black bg-[#CDCEB9] p-6 md:p-8 text-center">
        <div class="font-primary text-2xl md:text-3xl font-bold">Danke! 🎉</div>
        <div class="mt-3 font-primary text-black/80 text-base md:text-lg">
          Deine Nachricht wurde erfolgreich gesendet.
        </div>

        <div class="mt-8 flex justify-center">
          <button
            type="button"
            class="px-10 py-3 md:px-12 md:py-3.5 font-primary font-semibold uppercase tracking-[0.18em] border-2 border-black transition duration-300 bg-black text-[#d6d1cd] hover:bg-black/90"
            (click)="close()"
          >
            Schließen
          </button>
        </div>
      </div>
    }
  </div>
</div>
